<div class="container">
  <app-dashboard-layout></app-dashboard-layout>
  <!--<div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6" style="text-align: center">
      <h1>Ministerio de Justicia</h1>
    </div>
  </div>
  <br />
  <div class="row align-items-center">
    <div class="col-12 col-md-3">Opciones</div>
  </div>
  <div class="row align-items-center">
    <div class="col-12 col-md-3">
      <button
        class="btn-govco outline-btn-govco"
        routerLink="/expediente"
        [routerLinkActive]="'active'">
        Ir a Expedientes
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button
        class="btn-govco outline-btn-govco"
        routerLink="/administracion-usuarios/lista-administradores"
        [routerLinkActive]="'active'">
        Administración de usuarios lideres
      </button>
    </div>
  </div>
  <br />
  <div class="row align-items-center">
    <div class="col-12 col-md-3">
      <button (click)="alertaConfirmar()" class="btn-govco outline-btn-govco">
        Alerta Confirmar
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button (click)="alertaExito()" class="btn-govco outline-btn-govco">
        Alerta Exito
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button (click)="alertaAdvertencia()" class="btn-govco outline-btn-govco">
        Alerta Advertencia
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button (click)="alertaError()" class="btn-govco outline-btn-govco">
        Alerta Error
      </button>
    </div>
    <div class="col-12 col-md-1"></div>
  </div>
  <br />
  <div class="col-12 col-md-3">
    <button
      [routerLink]="['metricas-entidad']"
      [routerLinkActive]="'active'"
      class="btn-govco outline-btn-govco">
      Alertas Métricas
    </button>
  </div>

  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6" style="text-align: center">
      <h3>Procesos</h3>
    </div>
  </div>
  <br />
  <div class="row align-items-start mb-2">
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['administracion-funcional/visualizar-administrador']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Administracion MJD
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['procesos/sic']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Procesos SIC
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['procesos/dimar']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Procesos Dimar
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['procesos/dnda']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Procesos DNDA
      </button>
    </div>
  </div>
  <div class="row align-items-start mb-2">
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['procesos/supersalud']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Procesos Supersalud
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['procesos/superfinanciera']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Procesos Superfinanciera
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['procesos/ica']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Procesos ICA
      </button>
    </div>
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['procesos/supersociedades_mercantiles']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Procesos Supersociedades Mercantiles
      </button>
    </div>
  </div>
  <br />
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6" style="text-align: center">
      <h3>Integrador</h3>
    </div>
  </div>
  <div class="row align-items-start mb-2">
    <div class="col-12 col-md-3">
      <button
        [routerLink]="['formularios-enviados']"
        [routerLinkActive]="'active'"
        class="btn-govco outline-btn-govco">
        Formularios enviados
      </button>
    </div>
  </div>-->
</div>
<app-politica-tratamiento-datos-personales></app-politica-tratamiento-datos-personales>
